import { useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Modal } from '@playdapp/ui';

import { useAppSelector } from 'store/hooks';
import { chainIdToMainNetworkName } from 'lib/network';

const MoonpayBlock = styled.div`
  width: 100%;
  height: 600px;
  max-height: 100%;
  position: relative;
  z-index: 100;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 0%);
  background: white;
  border: none;
  border-radius: 2%;
  margin: 0px auto;
  display: block;

  form {
    background-color: white;
  }
`;

const MoonpayModal = styled.iframe`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  border: 0;
`;

const useMoonpay = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { chainId } = useAppSelector(({ wallet }) => wallet);

  const network = useMemo(
    () => (chainId ? chainIdToMainNetworkName[chainId] : null),
    [chainId],
  );

  const handleOpen = (isModalOpen: boolean) => {
    setIsOpen(isModalOpen);
  };

  return {
    isOpen,
    handleOpen,
    MoonPayModal: () => (
      <Modal
        isOpen={isOpen}
        handleOpen={handleOpen}
        width={{ xxl: '500px', sm: '400px' }}
      >
        <MoonpayBlock>
          <MoonpayModal
            allow="accelerometer; autoplay; camera; gyroscope; payment"
            width="100%"
            height="100%"
            frameBorder="0"
            src={`${
              process.env.NEXT_PUBLIC_ENV === 'development'
                ? `https://buy-sandbox.moonpay.com/?apiKey=pk_test_IJdQRcmzIyxIML9rhfVyip6C2OCyCZJ${
                    network === 'solana' ? '&defaultCurrencyCode=sol' : ''
                  }`
                : `https://buy.moonpay.com/?apiKey=pk_live_bQoNMMaUsQ37Nl5hSjussHm1ws43qO${
                    network === 'solana' ? '&defaultCurrencyCode=sol' : ''
                  }`
            }`}
          >
            <p>Your browser does not support iframes.</p>
          </MoonpayModal>
        </MoonpayBlock>
      </Modal>
    ),
  };
};

export default useMoonpay;
